import { useDispatch, useSelector } from "react-redux";
import { authSliceActions, selectAuth, selectIsImpersonating } from "store/authSlice";
import { api } from "api";
import { getProfile, logoutUrl } from "api/apiURLs";
import "./ImpersonationBanner.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSecret, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";

const ImpersonationBanner = () => {
    const isImpersonating = useSelector(selectIsImpersonating);
    const { userData } = useSelector(selectAuth);
    const dispatch = useDispatch();

    const handleStopImpersonation = async () => {
        // Revoke the impersonated session before discarding its credentials.
        // Restoration remains local-first if the server is temporarily down;
        // an admin must not be trapped in the impersonated identity.
        try {
            await api.post(logoutUrl, {});
        } catch {
            // Best effort; the original identity is restored below either way.
        }

        dispatch(authSliceActions.stopImpersonation());

        try {
            const response = await api.get(getProfile);
            dispatch(authSliceActions.hydrateProfile(response.data));
        } catch {
            // The reducer already restored the saved admin profile atomically,
            // so a transient profile failure cannot leave a vendor shown with
            // admin credentials (or bounce the admin to /login).
        }
    };

    if (!isImpersonating) return null;

    return (
        <div className="impersonation-banner">
            <FontAwesomeIcon icon={faUserSecret} />
            <span>
                أنت تتصفح كـ <strong>{userData?.name}</strong>
            </span>
            <button onClick={handleStopImpersonation}>
                <FontAwesomeIcon icon={faArrowRightFromBracket} />
                العودة لحسابك
            </button>
        </div>
    );
};

export default ImpersonationBanner;
